import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { status, user, profile, isAdmin } = useAuth();
  const loc = useLocation();
  // Wait for both session AND profile to resolve before evaluating isAdmin.
  // (AuthContext now awaits loadProfile before flipping status, but we keep
  // this guard as defense-in-depth against future signIn paths.)
  if (status === "loading" || (user && !profile)) {
    return (
      <div className="bg-paper min-h-[60vh] flex items-center justify-center text-ink/55 text-sm uppercase tracking-widest">
        Loading…
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent((loc.pathname || "/admin") + (loc.search || ""));
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}
